import PropTypes from 'prop-types';
import React from 'react';

import './styles.scss';

const componentBaseClass = 'qoc-button';
/* eslint-disable react/button-has-type */

const Button = (props = {}) => {
  const {
    classname,
    children,
    btnType = 'button',
    onClickHandler,
    disabled
  } = props;

  return (
    <div className={componentBaseClass}>
      <button
        type={btnType}
        className={`${classname}`}
        disabled={disabled}
        onClick={onClickHandler}
      >
        {children}
      </button>
    </div>
  );
};

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.string
  ]),
  disabled: PropTypes.bool,
  classname: PropTypes.string,
  onClickHandler: PropTypes.func,
  btnType: PropTypes.string
};

Button.defaultProps = {
  children: null,
  classname: '',
  disabled: false,
  onClickHandler: () => {},
  btnType: 'button'
};

export default Button;
